import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = logged out
  useEffect(() => {
    const token = localStorage.getItem("bides_token");
    if (!token) {
      setUser(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem("bides_token");
        setUser(false);
      });
  }, []);

  const login = (token, u) => {
    localStorage.setItem("bides_token", token);
    setUser(u);
  };
  const logout = () => {
    localStorage.removeItem("bides_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
